/*=========================================================================================
  File Name: module-licenseinfo-actions.js
  Description: LicenseInfo Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import MisaStoreAPI from '@/api/MisaStoreAPI.js';

export default {
	// Lấy thông tin mã kích hoạt Misa Store
	checkKeyStore: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: MisaStoreAPI.getAPIUrl() + `/checkstore/${payload.Key}`
			},
			true
		);
		// Trả kết quả
		return res;
	},
	// kích hoạt mã Misa Store và tạo tài khoản
	enableStoreKey: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: MisaStoreAPI.getAPIUrl() + `/enablestorekey`,
				data: payload
			},
			true
		);
		// Trả kết quả
		return res;
	},
	// kích hoạt mã Misa Store trong app
	enableStoreKeyInside: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: MisaStoreAPI.getAPIUrl() + `/enablestorekeyinside`,
				data: payload
			},
			true
		);
		// Trả kết quả
		return res;
	},
	// Lấy ra link direct sang misa store
	directToStore: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url:
					MisaStoreAPI.getAPIUrl() +
					`/direct/${payload.MisaId}/${payload.TaxCode}`
			},
			true
		);
		// Trả kết quả
		return res;
	}
};
